module.exports = __webpack_public_path__ + "img/plane_track_mobile_5.b9432ec9.svg";